export default __webpack_public_path__ + "static/media/MarsCentra-Bold.1f8a9bfd.ttf";